import React, {Component} from 'react';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import Modal from 'react-responsive-modal';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import Responsive from 'react-responsive';
import Slider from 'react-slick';

import LoadingBlock from '../../components/common/LoadingBlock';
// import StickyHeader from '../../components/onboarding/StickyHeader';
import ShareModule from '../../components/onboarding/ShareModule';
import SelectButton from '../../components/icon/SelectButton';
import StackedModals from '../../components/skinprofile/StackedModals';
import ShareModuleDummyDiv from '../../components/onboarding/ShareModuleDummyDiv';
import StepsHeader from '../../components/header/StepsHeader';
import ReviewProduct from  "../../components/review/reviewProduct";
import { skinConcernIcons, allergicIngredientIcons, budgetArray, productTypeUpdated, RESPONSE_STATUS } from '../../utils/constants';
import * as util from '../../utils/util';
import * as hairUtil from '../../utils/hairUtils';
import './SurveyResult.css';
import Api from '../../utils/api';
import HttpUtils from '../../utils/http';
import { getUserCartData } from '../../actions/cartAction';
import { buttonsContentManage } from '../../utils/util';

const indexMap = {1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true};
const indexMapThreeFive = {13:true,14:true};
const indexMapProducts = {1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,11:true,12:true,15:true};
const indexMapBudget = { 2:true, 3:true, 4:true};
const numOfProductsForReview = 3;

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slick-arrow custom-arrow-left"} style={onClick ? null : {display:'none'}}
        onClick={onClick}
      />
    );
}

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slick-arrow custom-arrow-right"}  style={onClick ? null : {display:'none'}}
        onClick={onClick}
      />
    );
}

class SurveyResultNew extends Component {
    constructor(props){
        super(props);

        this.handleCheckout = this.handleCheckout.bind(this);
        this.syncProducts = this.syncProducts.bind(this);
        this.handleAvaChat = this.handleAvaChat.bind(this);
        this.selectPasIcon = this.selectPasIcon.bind(this);
        this.deselectPasIcon = this.deselectPasIcon.bind(this);
        this.saveProducts = this.saveProducts.bind(this);
        this.saveAllergies = this.saveAllergies.bind(this);
        this.saveSkinConcerns = this.saveSkinConcerns.bind(this);
        this.getProductsForReview = this.getProductsForReview.bind(this);
        this.saveBudget = this.saveBudget.bind(this);
        this.directToLandingPage = this.directToLandingPage.bind(this);
        this.toggleShareCard = this.toggleShareCard.bind(this);
        this.hideDummyDiv = this.hideDummyDiv.bind(this);
        this.closeReviewModal = this.closeReviewModal.bind(this);
        this.fun_ShowSkinConten = this.fun_ShowSkinConten.bind(this);
        this.pageOfProductsForReview = 0;


        this.state = {
            loadingDone: false,
            width: document.documentElement.clientWidth,
            skinType: '',
            description: '',
            descriptionShowText:'',
            strength: '',
            strengthShowText: '',
            weakness: '',
            weaknessShowText: '',
            recommendedProducts: [],
            skinConcerns: [],
            productTypes: [],
            allergicIngredients: [],
            budget: null,
            openModal: false,
            isEditingProducts: false,
            isEditingAllergies: false,
            isEditingSkinConcerns: false,
            isEditingBudget: false,
            selectedAllergicMap: {},
            selectedSkinConcernMap: {},
            selectedGenderId: null,
            productsForReview: [],
            descriptionExpanded: false,
            strengthExpanded: false,
            weaknessExpanded: false,
            showRecommendations: false,
            recommendationButtonText: "View My Recommendations",
            visitedRecommendations: false,
            showDummyDiv: false,
            optInTimerStarted: false,
            gateFeePaid: false,
            openReviewModal: false,
            productInfo:[],
            isShowSummary:true,
            isShowStrength:true,
            isShowWeakness:true,
            recommendedIngredients:[],
            skinContenType:  util.isMobile(navigator.userAgent) ? 'strength'  :   'summary',
            routineSelectType:'AM',
            selectedProductTypes:[],
            meetYourRoutineData:{},

            ingredientsProdct_SliderSettings:{
                dots: false,
                infinite: false,
                speed: 250,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows:false,
               
                responsive: [
                  {
                    breakpoint: 900,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1,
                    }
                  },
              
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      prevArrow: <SamplePrevArrow />,
                      nextArrow: <SampleNextArrow />,
                      arrows:true,
                      infinite: false,
                    }
                  },
                  {
                    breakpoint: 320,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      prevArrow: <SamplePrevArrow />,
                      nextArrow: <SampleNextArrow />,
                      arrows:true,
                      infinite: false,
                    }
                  }
                ],
              }
            
        };

        this.products = [];
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleMediaQueries.bind(this));
        // util.surveryProctRecommendation()


        if( localStorage.getItem("visited_recommendations") == "true" ){
            this.setState({visitedRecommendations: true});
        }else{
            this.setState({visitedRecommendations: false});
            if(localStorage.getItem("visited_recommendations") == null ){

                Api.checkIsShowRecommendation({
                    userId: localStorage.getItem("user_id"),
                    token:{token: localStorage.getItem("auth_token")}
                }).then(()=>{
                    if( localStorage.getItem("visited_recommendations") == "true" ){
                        this.setState({visitedRecommendations: true});
                    }else{
                        this.setState({visitedRecommendations: false});
                    }
                })
            }
        }

        if(localStorage.getItem("planTier") == null || localStorage.getItem("planTier") == "null" ){
            Api.getPlanTypeTierData();
        }

        HttpUtils.get("/api/ingredient-recommendation?user-id="+localStorage.getItem("user_id")).then(response =>{
            this.setState({
                recommendedIngredients: response['recommendedIngredients']
            });
        });
        
        if(localStorage.getItem("gateFeePaid") == null){
            Api.checkIfPaidGateFee({
                userId: localStorage.getItem("user_id"),
                token:{token: localStorage.getItem("auth_token")}
            })
        }

        //判断手机号码尾号是否为5 - 9
    //   var phoneNumber = localStorage.getItem("phone_number");
    //   if(phoneNumber && phoneNumber != null){
    //     var phoneEndNumber = phoneNumber.substring(phoneNumber.length-1);
    //     if((phoneEndNumber*1) >= 5 ){

    //       window.zESettings = {
    //         webWidget: {
    //           chat: {
    //             title: {'*': 'Have a skin question?'},
    //             prechatForm: {
    //               greeting: {
    //               '*': 'Please enter the email address associated with your skin profile.'
    //               }
    //             }
    //           }
    //         }
    //       };

    //       window.zE("webWidget", {chat: {
    //         supress: false
    //       }}, "show");
    //     }
    //   }
      // end 手机号码尾号是否为5 - 9

        // 获取需要评论的商品。用户最后一次购物的订单商品
        HttpUtils.get("/api/user-order-products/review?user-id="+localStorage.getItem("user_id")).then(response =>{
        this.setState({
            productInfo: response
        },()=>{
            if(response.length > 0){
                this.setState({openReviewModal: true})
            }else{
                this.setState({openReviewModal: false})
            }
        })
        }).catch(err => {
            console.log(err.statusText);
        })
  }

  componentWillMount() {
        const userId = localStorage.getItem("user_id");
        if (userId) {
            if (this.state.productsForReview) {
                this.getGenderId();
                this.fetchResult();
                // this.getProductsForReview();
                // this.checkDefaultPurchaseStatus();
            }

            this.props.getUserCartData()
            this.checkIfPaidGateFee()
        } else {
            this.props.history.push('/signin');
        }
    }

    handleMediaQueries() {
        this.setState({
            width: document.documentElement.clientWidth
        });
    }

    // Determine whether to paid for the gate fee。true：progress bar states change Consultation
    //是否已经支付了咨询费
    checkIfPaidGateFee() {
        if(localStorage.getItem("gateFeePaid") == "true"){
            this.setState({ gateFeePaid: true });
        }else{
            this.setState({ gateFeePaid: false })
        }
    }

    //新的改动这个不需要了

    // checkDefaultPurchaseStatus() {
    //     const userId = localStorage.getItem("user_id");
    //     fetch('/api/default-purchases?user-id=' + userId, {
    //         method: 'GET',
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //             'x-auth-token': Api.auth_tokenManager()
    //         }
    //     })
    //     .then(response => {
    //         if (response.status >= 400 && response.status < 500) {
    //             this.setState({ optInTimerStarted: true })
    //             return;
    //         } else {
    //             return response.json();
    //         }
    //     })
    //     .then(responseJson => {
    //          if ((responseJson.status === "complete") || (responseJson.status === "opt-out")) {
    //             this.setState({
    //                 optInTimerStarted: false
    //             });
    //         } else {
    //             this.setState({
    //                 optInTimerStarted: true
    //             });
    //         }


    //     })
    //     .catch(err => {
    //         console.log(err);
    //         // alert('There was a problem checking if timer had already started: ' + err);
    //     });
    // }

    getGenderId() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/user-account-info/' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({
                selectedGenderId: responseJson.gender && responseJson.gender.id });
                localStorage.setItem("user_global_firstname", responseJson.firstName);
                localStorage.setItem("user_global_lastname", responseJson.lastName);
                localStorage.setItem("user_global_email", responseJson.email);
                localStorage.setItem("user_global_phone", responseJson.phoneNumber);
                localStorage.setItem("user_global_hasPaid", responseJson.hasPaid);
                if(!! responseJson){
                    localStorage.setItem("user_account_info", JSON.stringify(responseJson));
                }

                responseJson.gender && localStorage.setItem("user_global_gender", responseJson.gender.id);

        }).catch(function(err) {
            console.log("There is a problem to get the account info. Please try again.");
        });
    }

    handleCheckout() {
        const count = this.products.reduce((res, val) => res + parseInt(val.split(":")[1],10), 0);
        if (count <= 0) {
            alert("You must select at least one product.");
            return;
        }
        let url = 'https://helloava.myshopify.com/cart/' + this.products.toString();
        window.open(url);
        // if (process.env.REACT_APP_ENV === 'prod') {
        //     ReactGA.event({
        //         category: 'Checkout Funnel',
        //         action: 'Click',
        //         label: 'Checkout',
        //         value: 1
        //     });
        // }
    }

    syncProducts(prev, curr) {
        let arr = this.products;
        let i = arr.indexOf(prev);

        if(i !== -1){
            arr.splice(i, 1);
        }

        if(curr.indexOf(":0") === -1) {
            arr.push(curr);
        }

        this.products = arr;
    }

    fetchResult() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/surveys/result?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            var descriptionShowText = responseJson.description,
            strengthShowText = responseJson.strength,
            weaknessShowText = responseJson.weakness;
            try {
                if(util.isMobile(navigator.userAgent)){
                    descriptionShowText = responseJson.description.substring(0,133);
                    strengthShowText = responseJson.strength.substring(0,133);
                    weaknessShowText = responseJson.weakness.substring(0,133);
                }
            } catch (error) {
            }

            localStorage.setItem("estheticianNote", responseJson['response']);
                
            this.setState({
                selectedProductTypes:responseJson.selectedProductTypes,
                skinType: responseJson.type, 
                description: responseJson.description,
                descriptionShowText: descriptionShowText,

                strength: responseJson.strength+'',
                strengthShowText: strengthShowText+'',

                weakness: responseJson.weakness+'',
                weaknessShowText: weaknessShowText+'',

                recommendedProducts: responseJson.recommendedProducts,
                budget: responseJson.selectedBudgetId,
                skinConcerns: responseJson.skinConcerns, productTypes: responseJson.productTypes.length > 0 && (responseJson.productTypes.indexOf(9) === -1 && responseJson.productTypes.indexOf(10) === -1) ? responseJson.productTypes : [1,2,3], allergicIngredients: responseJson.allergicIngredients
            },()=>{
                this.fun_getMeetYourRoutineData();
            });


            if(util.isMobile(navigator.userAgent)){
                if(responseJson.description.length > 133 ){
                    this.setState({ isShowSummary: true,descriptionShowText: this.state.descriptionShowText+" ..." });
                }else{
                    this.setState({ isShowSummary: false });
                }
    
                if(responseJson.strength.length > 133 ){
                    this.setState({ isShowStrength: true,strengthShowText: this.state.strengthShowText+" ..."  });
                }else{
                    this.setState({ isShowStrength: false });
                }
    
                if(responseJson.weakness.length > 133 ){
                    this.setState({ isShowWeakness: true,weaknessShowText: this.state.weaknessShowText+" ..." });
                }else{
                    this.setState({ isShowStrength: false });
                }
            }
         

            let indexNine = this.state.productTypes.indexOf(9);
            let indexTen = this.state.productTypes.indexOf(10);
            if (indexNine !== -1) this.state.productTypes.splice(indexNine, 1);
            if (indexTen !== -1) this.state.productTypes.splice(indexTen, 1);
            if (this.state.productTypes.length < 1) this.setState({ productTypes: [10] });
            if (this.state.allergicIngredients.length < 1) this.setState({ allergicIngredients: [1] });
            if (this.state.skinConcerns.length < 1) this.setState({ skinConcerns: [10] });
            if (this.state.budget === null) this.setState({ budget: 4 });
            this.setState({ loadingDone: true });
        }).catch(function(err) {
            console.log("   There is a problem to get the survey result. Please try again.");
        });
    }

    fun_getMeetYourRoutineData(){
        var selectedProductTypes = this.state.selectedProductTypes; // 用户选择的
        var baseData = util.surveryProctRecommendation(this.state.skinType);
        var amData = baseData['AM'];
        var pmData = baseData['PM'];
        var weeklyData = baseData['WEEKLY'];

        var mustTypeData = ['Cleanser','Serum','Moisturizer','SPF','Mask'];
        mustTypeData.forEach(element => {
            if(selectedProductTypes.indexOf(element) == -1 ){
                selectedProductTypes.push(element)
            }
        });//end 经过了这步，用户选择的类型加上必须展示的类型合并了
      
       
        var _amData = [];
        for (const key in amData) {
            if (Object.hasOwnProperty.call(amData, key)) {
                if(selectedProductTypes.indexOf(key) != -1 ){
                    _amData.push({[key]:amData[key]})
                }
            }
        }

        var _pmData = [];
        for (const key in pmData) {
            if (Object.hasOwnProperty.call(pmData, key)) {
                if(selectedProductTypes.indexOf(key) != -1 ){
                    _pmData.push({[key]:pmData[key]})
                }
            }
        }

        var _weeklyData = [];
        // if(selectedProductTypes.indexOf("Mask") == -1 ){
        //     delete weeklyData['Mask'];
        //     _weeklyData = weeklyData;
        // }
        // _weeklyData = weeklyData;


        for (const key in weeklyData) {
            if (Object.hasOwnProperty.call(weeklyData, key)) {

                if(selectedProductTypes.indexOf(key) != -1 ){
                    _weeklyData.push({[key]:weeklyData[key]})
                }
            }
        }

        this.setState({
            meetYourRoutineData: { "AM" : _amData , "PM":  _pmData , "WEEKLY":  _weeklyData }
        });
        

    }

    getProductsForReview() {
        const userId = localStorage.getItem("user_id");
        const url = '/api/user-order-products/review?user-id=' + userId + '&page=' + this.pageOfProductsForReview + '&size=' + numOfProductsForReview;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({ productsForReview: responseJson });
            this.pageOfProductsForReview += 1;
        }).catch(function(err) {
            alert("There is a problem to get the products for review. Please try again.");
        });
    }

    handleAvaChat(){
        this.props.history.push("/chat");
    }

    openModal() {
        this.setState({ openModal: true });
    }

    closeModal() {
        this.setState({ openModal: false });
    }

    selectPasIcon(id) {
        const splits = id.split("-");
        const type = splits[0];
        let index = splits[1];
        if (type === 'product') {
            let productTypes = this.state.productTypes;
            index = parseInt(index, 10);
            if ((index !== 13) && (index !== 14)) {
                let indexThirteen = productTypes.indexOf(13);
                let indexFourteen = productTypes.indexOf(14);
                if (indexThirteen > -1) productTypes.splice(indexThirteen, 1);
                if (indexFourteen > -1) productTypes.splice(indexFourteen, 1);
                productTypes.push(parseInt(index,10));
                this.setState({ productTypes: productTypes });
            }else if(type === 'all'){
                // this.setState({ productTypes: [11, 12, 15, 2, 3, 4, 5, 6, 7, 8, 1] });
            } else {
                productTypes = [];
                productTypes.push(index);
                this.setState({ productTypes: productTypes });
            }
        } else if (type === 'allergic') {
            let allergicIngredients = this.state.allergicIngredients;
            allergicIngredients.push(parseInt(index,10));
            this.setState({ allergicIngredients: allergicIngredients });
        } else if (type === 'skinconcern') {
            let skinConcerns = this.state.skinConcerns;
            skinConcerns.push(parseInt(index,10));
            this.setState({ skinConcerns: skinConcerns });
        } else {
            this.setState({ budget: index });
        }

    }

    deselectPasIcon(id) {
        const splits = id.split("-");
        const type = splits[0];
        let index = splits[1];
        if (type === 'product') {
            let productTypes = this.state.productTypes;
            index = parseInt(index, 10);
            productTypes.splice(productTypes.indexOf(index), 1);
            if(this.state.productTypes.indexOf(index) === -1) productTypes.slice(this.state.productTypes.indexOf(index), 1);
            this.setState({ productTypes: productTypes });
        } else if (type === 'allergic') {
            let allergicIngredients = this.state.allergicIngredients;
            index = parseInt(index, 10);
            allergicIngredients.splice(allergicIngredients.indexOf(index), 1);
            if(this.state.allergicIngredients.indexOf(index) === -1) allergicIngredients.slice(this.state.allergicIngredients.indexOf(index), 1);
            this.setState({ allergicIngredients: allergicIngredients });
        } else if (type === 'skinconcern') {
            let skinConcerns = this.state.skinConcerns;
            index = parseInt(index, 10);
            skinConcerns.splice(skinConcerns.indexOf(index), 1);
            if(this.state.skinConcerns.indexOf(index) === -1) skinConcerns.slice(this.state.skinConcerns.indexOf(index), 1);
            this.setState({ skinConcerns: skinConcerns });
        }
    }

    saveProducts() {
        const productTypes = this.state.productTypes;
        const userId = localStorage.getItem("user_id");
        const url = "/api/user-product-types?user-id=" + userId + "&options=" + productTypes;
        if (productTypes.length === 0) {
            alert("You must select at least one product type.");
            return;
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ isEditingProducts: false });
                this.fetchResult();
            } else {
                alert("There was a problem to saving your products. Please try again.");
            }
        });
    }

    saveAllergies() {
        const selectedIndices = this.state.allergicIngredients;
        // const selectedIndices = Object.keys(selectedAllergicMap);
        if (selectedIndices.length === 0) {
            alert("You must select at least one option.");
            return;
        }
        const userId = localStorage.getItem("user_id");
        const url = "/api/user-allergic-ingredients?user-id=" + userId + "&options=" + selectedIndices;
        fetch(url, {
            method: 'POST',
            headers: {
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ isEditingAllergies: false });
                this.fetchResult();
            } else {
                alert("There was a problem saving your allergies. Please try again.");
            }
        });
    }

    saveSkinConcerns() {
        const skinConcerns = this.state.skinConcerns;
        const userId = localStorage.getItem("user_id");
        const url = "/api/user-skin-concerns?user-id=" + userId + "&options=" + skinConcerns;
        if (skinConcerns.length === 0) {
            alert("You must select at least one option.");
            return;
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ isEditingSkinConcerns: false });
                this.fetchResult();
            } else {
                alert("There was a problem saving your skin concerns. Please try again.");
            }
        });
    }

    saveBudget() {
        const userId = localStorage.getItem("user_id");
        const url = "/api/user-profiles";
        fetch(url, {
            method: 'PATCH',
            headers: {
                'x-auth-token': Api.auth_tokenManager(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: userId,
                budgetId: this.state.budget
            })
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ isEditingBudget: false });
                this.fetchResult();
            } else {
                alert("There was a problem saving your budget preferences. Please try again.");
            }
        });
    }


    toggleSummary() {
        this.setState({
            descriptionExpanded: !this.state.descriptionExpanded
        });


    }

    toggleStrength() {
        this.setState({
            strengthExpanded: !this.state.strengthExpanded
        });
    }

    toggleWeakness() {
        this.setState({
            weaknessExpanded: !this.state.weaknessExpanded
        });
    }

    toggleRecommendations() {
        const showRecommendations = this.state.showRecommendations;
        let recommendationButtonText = showRecommendations ? "View My Recommendations" : "Hide My Recommendations";

        this.setState({
            showRecommendations: !this.state.showRecommendations,
            recommendationButtonText: recommendationButtonText
        });
    }

    directToLandingPage() {
        // const phoneNumber = localStorage.getItem('phone_number');
        // if (phoneNumber) {
        //     const phoneNumberLength = phoneNumber.length;
        //     return phoneNumber[phoneNumberLength - 1] > 4;
        // }

        // if (util.isMobile(navigator.userAgent)) {
        //     return true;
        // }

        return true;
    }

    toggleShareCard(callback) {
        this.setState({
            showDummyDiv: true
        }, function() {
            if (this.state.showDummyDiv) callback();
        });
    }

    hideDummyDiv() {
        this.setState({ showDummyDiv: false });
    }

    fun_ownSelectAll() {
        this.setState({ productTypes: [11, 12, 15, 2, 3, 4, 5, 6, 7, 8, 1] });
    }

    closeReviewModal() {
        this.setState({
          openReviewModal: false
        })
    }

    handSkinReportOpen(name){
       try {
        this.setState({
            [name]: !this.state[name],
        })
        var showTextName = 'descriptionShowText';
        if(name == "isShowSummary"){
            showTextName = "descriptionShowText";
        }else if(name == "isShowStrength"){
            showTextName = "strengthShowText";
        }else if(name == "isShowWeakness"){
            showTextName = "weaknessShowText";
        }

        if(!this.state[name]){
            this.setState({
                [showTextName]: this.state[showTextName.replace("ShowText","")].substring(0,133)+" ...",
            })
        }else{
            this.setState({
                [showTextName]: this.state[showTextName.replace("ShowText","")]+"",
            })
        }
       } catch (error) {
           
       }
    }

    fun_ShowSkinConten(type){
        this.setState({
            skinContenType:type
        });
    }

    fun_routineSelectType(type){
        this.setState({
            routineSelectType:type
        })
    }

    render() {
        const skinType = this.state.skinType;
        const skinTypeDisplay = this.state.skinType.replace("W", "M");

        const dryOily = !this.state.skinType ? null : (skinType.charAt(0) !== 'O' && skinType.charAt(0) !== 'C') && skinType.charAt(0) !== 'D' ? null : (skinType.charAt(0) === 'O'? "oily" : (skinType.charAt(0) === 'C'? "combination": "dry"));
        const sensitiveResistant = !this.state.skinType ? null : skinType.charAt(1) !== 'S' && skinType.charAt(1) !== 'R' ? null : (skinType.charAt(1) === 'S'? "sensitive" : "Non-sensitive");
        
        const pigmented =  !this.state.skinType ? null : skinType.charAt(2) !== 'H' && skinType.charAt(2) !== 'L' ? null : (skinType.charAt(2) === 'H'? "pigmented" : "non-pigmented");
        const wrinkled = !this.state.skinType ? null : skinType.charAt(3) !== 'M' && skinType.charAt(3) !== 'Y' ? null : (skinType.charAt(3) === 'M'? "mature" : "Youthful");
        //PRODUCTS
        // const isEditingProducts = this.state.isEditingProducts;

        // const selectedProductOptions = this.state.productTypes.sort().map(index => {
        //     let name = util.capitalize(productTypeUpdated[index - 1].replace(".svg", "").replace("-", " "));
        //     if (index === 13 || index === 14) {
        //         return (
        //             <div key={ index } className="option full" >
        //             <SelectButton name={ name } selectable={ isEditingProducts }
        //                 selected={ true } id={ "product-" + index }
        //                 onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //             </div>
        //         );
        //     }
        //     return (
        //         <div key={ index } className="option" >
        //             <SelectButton name={ name } selectable={ isEditingProducts }
        //                 selected={ true } id={ "product-" + index }
        //                 onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //         </div>
        //     );
        // });

        // let allProductThreeFiveMap = Object.assign({}, indexMapThreeFive);
        // let allProductMap = Object.assign({}, indexMapProducts);
        // const allProductOptionsThreeFive = Object.keys(allProductThreeFiveMap).sort().map(index => {
        //     let name = util.capitalize(productTypeUpdated[index - 1].replace(".svg", "").replace("-", " "));
        //    return (
        //         <div key={ index } className="option full" >
        //         <SelectButton name={ name } selectable={ isEditingProducts }
        //             selected={ this.state.productTypes && this.state.productTypes.indexOf(parseInt(index, 10)) > -1 } id={ "product-" + index }
        //             onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //         </div>
        //     );
        // });
        // const allProductOptions = Object.keys(allProductMap).sort().map(index => {
        //     let name = util.capitalize(productTypeUpdated[index - 1].replace(".svg", "").replace("-", " "));
        //     return(
        //         <div key={ index } className="option" >
        //             <SelectButton name={ name } selectable={ isEditingProducts }
        //             selected={ this.state.productTypes && this.state.productTypes.indexOf(parseInt(index, 10)) > -1 } id={ "product-" + index }
        //             onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //         </div>
        //     );
        // });

        //ALLERGENS
        // const isEditingAllergies = this.state.isEditingAllergies;

        // const selectedAllergicOptions = this.state.allergicIngredients.sort().map(index => {
        //     return (
        //         <div key={ index } className="option">
        //             <SelectButton name={  util.capitalize(allergicIngredientIcons[index - 1].replace(".svg", "").replace("-", " ")) } selectable={ isEditingAllergies }
        //                 selected={ true } id={ "allergic-" + index }
        //                 onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //         </div>
        //     );
        // });

        // let selectedAllergicMap = Object.assign({}, indexMap);
        // const allAllergicOptions = Object.keys(selectedAllergicMap).sort().map(index => {
        //     return (
        //         <div key={ index } className="option">
        //             <SelectButton name={  util.capitalize(allergicIngredientIcons[index - 1].replace(".svg", "").replace("-", " ")) } selectable={ isEditingAllergies }
        //                 selected={ this.state.allergicIngredients && this.state.allergicIngredients.indexOf(parseInt(index, 10)) > -1 } id={ "allergic-" + index }
        //                 onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //         </div>
        //     );
        // });

        //SKIN CONCERNS
        // const isEditingSkinConcerns = this.state.isEditingSkinConcerns;

        // const selectedSkinConcernOptions = this.state.skinConcerns.sort().map(index => {
        //     return (
        //         <div key={ index } className="option">
        //             <SelectButton name={  util.capitalize(skinConcernIcons[index - 1].replace(".svg", "").replace("-", " ")) } selectable={ isEditingSkinConcerns }
        //                 selected={ true } id={ "skinconcern-" + index }
        //                 onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //         </div>
        //     );
        // });

        // let selectedSkinConcernMap = Object.assign({}, indexMap);
        // const allSkinConcernOptions = Object.keys(selectedSkinConcernMap).sort().map(index => {
        //     return (
        //         <div key={ index } className="option">
        //             <SelectButton name={ util.capitalize(skinConcernIcons[index - 1].replace(".svg", "").replace("-", " ")) } selectable={ isEditingSkinConcerns }
        //                 selected={ this.state.skinConcerns && this.state.skinConcerns.indexOf(parseInt(index, 10)) > -1 } id={ "skinconcern-" + index }
        //                 onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //         </div>
        //     );
        // });

        // //BUDGET
        // const isEditingBudget = this.state.isEditingBudget;

        // const selectedBudgetOptions =
        //         <div key={ this.state.budget } className="option">
        //             <SelectButton name={ budgetArray[this.state.budget - 1] } selectable={ isEditingBudget }
        //                 selected={ true } id={ "budget-" + this.state.budget }
        //                 onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //         </div>

        // let selectedBudgetMap = Object.assign({}, indexMapBudget);

        // const allBudgetOptions = Object.keys(selectedBudgetMap).sort().map(index => {
        //     return (
        //         <div key={ index } className="option">
        //             <SelectButton name={ budgetArray[index - 1] } selectable={ isEditingBudget }
        //                 selected={ parseInt((index), 10) === parseInt(this.state.budget, 10) } id={ "budget-" + index }
        //                 onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
        //         </div>
        //     );
        // });

        const userFirstName = localStorage.getItem('user_firstname');
        const productsForReview = this.state.productsForReview;

        return (


            <div id="survey-result" className={"survey-result" }>
                <Helmet>
                    <title>Skin Profile - HelloAva</title>
                    <meta name="description" content="Here are the results of your skin care questionaire!" />
                </Helmet>
                {
                    this.state.loadingDone ?
                    <div className="loading-done-survey-result publicView" style={{marginTop:'0',marginBottom:'0'}}>
                        <div className="title-hello-name profile-title-hello-name">
                            <div className="t-h-name-text-area">
                                <div className="t-h-name">
                                    <img src="./images/profile/hand.svg"/> 
                                    <span className="heading1">Hello, { userFirstName }!</span>
                                </div>
                                <span className="paragraphRegular2">Your skin journey starts here</span>
                            </div>
                        </div>
                        

                        <div id="survey-result-body" className="survey-result-body plan-area-style">
                            <div id="survey-result-content" className="survey-result-content">
                                <div id="about-you-section" className="about-you-section">

                                    <div id="skin-type-section" className="skin-type-section">
                                        <div className="skin-type-zone-title heading_caps1 navy">YOUR SKIN TYPE</div>
                                        <div className="skin-type">
                                            <div className="skin-type-conten">
                                                <div className="column">
                                                    <div className="column-img">
                                                        <img alt={ dryOily } src={ "/images/onboarding/skintypeupdated/" + dryOily + ".svg" } />
                                                    </div>
                                                    <div className="type">{ dryOily }</div>
                                                </div>

                                                <div className="column">
                                                    <div className="column-img">
                                                        <img alt={ sensitiveResistant } src={ "/images/onboarding/skintypeupdated/" + sensitiveResistant + ".svg" } />
                                                    </div>                                                   
                                                    <div className="type">{ sensitiveResistant }</div>
                                                </div>

                                                <div className="column">
                                                    <div className="column-img">
                                                        <img alt={ pigmented } src={ "/images/onboarding/skintypeupdated/" + pigmented + ".svg" } />
                                                    </div>   
                                                    <div className="type">{ pigmented }</div>
                                                </div>

                                                <div className="column">
                                                    <div className="column-img">
                                                        <img alt={ wrinkled } src={ "/images/onboarding/skintypeupdated/" + wrinkled + ".svg" } />
                                                    </div>
                                                    <div className="type">{ skinType.charAt(3) === 'M'? "mature" : "Youthful" }</div>
                                                </div>
                                            </div>
                                            
                                            <div className="skin-overview">

                                                <Responsive minWidth={ 767 }>
                                                    <div className="s-o-top-type">
                                                        <ul className="paragraphBold2">
                                                            <li onClick={()=>{this.fun_ShowSkinConten("summary")}} className= {this.state.skinContenType == "summary" ? "action":""}>Summary</li>
                                                            <li onClick={()=>{this.fun_ShowSkinConten("weakness")}} className= {this.state.skinContenType == "weakness" ? "action":""}>Weakness</li>
                                                            <li onClick={()=>{this.fun_ShowSkinConten("strength")}} className= {this.state.skinContenType == "strength" ? "action":""}>Strength</li>
                                                        </ul>
                                                    </div>
                                                </Responsive>

                                                <Responsive maxWidth={ 767 }>
                                                    <div className="s-o-top-type">
                                                        <ul className="paragraphBold2">
                                                            <li className="mobile-s-o-li">Summary</li>
                                                        </ul>
                                                    </div>
                                                    <div className="s-o-skin-conten-text paragraphRegular3">{this.state.description}</div>

                                                    <div className="s-o-top-type">
                                                        <ul className="paragraphBold2">
                                                            <li onClick={()=>{this.fun_ShowSkinConten("strength")}} className= {this.state.skinContenType == "strength" ? "action":""}>Strength</li>
                                                            <li onClick={()=>{this.fun_ShowSkinConten("weakness")}} className= {this.state.skinContenType == "weakness" ? "action":""}>Weakness</li>
                                                        </ul>
                                                    </div>
                                                </Responsive>


                                                <div className="s-o-skin-conten-text paragraphRegular3">
                                                    {
                                                        this.state.skinContenType == "summary" ? this.state.description : ( this.state.skinContenType == "strength" ? this.state.strength : this.state.weakness ) 
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="ingredients-section-area">
                                        <div className="skin-section-area">
                                            <div className="ingredients-title-text">TOP INGREDIENTS FOR YOUR SKIN</div>
                                        </div>
                                         

                                         <div className="ingredients-prodct-area">
                                            <Slider { ...this.state.ingredientsProdct_SliderSettings } >
                                                {
                                                    this.state.recommendedIngredients.map((data, index) => {
                                                        return (
                                                            <div className="ingredients-prodct-item" key={index}>
                                                                <div className="ingredients-prodct-item-wi">
                                                                    <div className="ingredients-pr-item-top">
                                                                        <img src={data.image}></img>
                                                                    </div>

                                                                    <div className="ingredients-pr-item-conten-text">
                                                                        <span className="heading_alt4">{data.name}</span>
                                                                        <ul className="paragraphRegular4">
                                                                            <li className="ingred-item-li-title">Targets your:</li>
                                                                            {
                                                                                data['skinConcerns'].map((data,index) => {
                                                                                    return(
                                                                                        <li key={index} className="ingred-item-li">
                                                                                            { util.textToUpperCase(data)  }
                                                                                        </li>
                                                                                    )
                                                                                })  
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>                 
                                                        );
                                                    })
                                                } 
                                             </Slider>
                                         </div>
                                    </div>

                                    <div className="skin-section-area">
                                        <div className="heading_caps1 navy">MEET YOUR ROUTINE</div>
                                        <div className="my-routine-area">
                                            <div className="my-routine-title-label">
                                                <div onClick={()=>{ this.fun_routineSelectType('AM') }}  className={this.state.routineSelectType == 'AM' ? "action" :""} >☀️ AM</div>
                                                <div onClick={()=>{ this.fun_routineSelectType('PM') }} className={this.state.routineSelectType == 'PM' ? "action" :""} >🌙 PM</div>
                                            </div>

                                            <div className="m-rouine-list-data">
                                                <ul className="am-area" style={ this.state.routineSelectType == 'AM' ? { display:'block'} : { display:'none'} }>
                                                {
                                                    this.state.meetYourRoutineData['AM'].map((data, index) => {
                                                        return (
                                                            <li key={index}>
                                                                <i className="serialNumber_i">{index+1}</i>
                                                                <span className="paragraphSemiBold1">{ Object.keys(data)}</span>
                                                                <span className="paragraphRegular3">{   data[Object.keys(data)]    }</span>
                                                            </li>
                                                        )
                                                    })  
                                                }
                                                </ul>

                                                <ul className="pm-area" style={ this.state.routineSelectType == 'PM' ? { display:'block'} : { display:'none'} }>
                                                {
                                                    this.state.meetYourRoutineData['PM'].map((data, index) => {
                                                        return (
                                                            <li key={index}>
                                                                <i className="serialNumber_i">{index+1}</i>
                                                                <span className="paragraphSemiBold1">{ Object.keys(data)}</span>
                                                                <span className="paragraphRegular3">{   data[Object.keys(data)]    }</span>
                                                            </li>
                                                        )
                                                    })    
                                                }
                                                </ul>
                                            </div>

                                            <div className="m-r-weekly-area">
                                                <div className="m-r-weekly-title paragraphBold2">WEEKLY</div>
                                                <ul>
                                                    {
                                                        this.state.meetYourRoutineData['WEEKLY'].map((data, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <span className="paragraphSemiBold1">{Object.keys(data)}</span>
                                                                    <span className="paragraphRegular3">{data[Object.keys(data)]}</span>
                                                                </li>
                                                            )
                                                        })  
                                                    }
                                                </ul>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="skin-section-area">
                                        <div className="heading_caps1 navy">BRAND HIGHLIGHTs</div>
                                        <div className="my-routine-area brand-highlights-area">

                                            <div>
                                                <Responsive minWidth={ 767 }>
                                                    <img src="./images/profile/brand/PCA-skin.png"></img>
                                                </Responsive>
                                                <Responsive maxWidth={ 767 }>
                                                    <img src="./images/profile/brand/mad-hipple.png"></img>
                                                </Responsive>
                                            </div>

                                            <div><img src="./images/profile/brand/Herbivore.png"></img></div>

                                            <div><img src="./images/profile/brand/bloderma.png"></img></div>



                                            <div>
                                                <img src="./images/profile/brand/avene-logo.png"></img>
                                            </div>

                                            <div> 
                                                <img src="./images/profile/brand/sunday-riley.png"></img>
                                            </div>

                                            <div>
                                                <Responsive minWidth={ 767 }>
                                                    <img src="./images/profile/brand/brand-logo-dear-klairs.png"></img>
                                                </Responsive>
                                                <Responsive maxWidth={ 767 }>
                                                    <img src="./images/profile/brand/indie-lee.png"></img>
                                                </Responsive>
                                            </div>



                                            <div><img src="./images/profile/brand/Perricone-MD.png"></img></div>

                                            <div>
                                                <img src="./images/profile/brand/COSRX.png "></img>
                                            </div>


                                            <div>
                                                <img src="./images/profile/brand/supergoop.png"></img>
                                            </div>
                                            
                                        </div>
                                        <div className="paragraphRegular3 Navy brand-highlights-text">We vet brands with 100% care. These are some of the best that offer products we will recommend that are going to transform your skin.</div>
                                    </div>    

                                </div>
                            </div>
                        </div>

                            <div id="recommendation-button-section">
                                {/* <a href={!this.state.gateFeePaid && ! this.state.visitedRecommendations ? "/plan" : !this.state.visitedRecommendations ? "/recommendation-landing" : "/recommendations"}><button>Access Full Product List</button></a> */}
                                <a href={buttonsContentManage('recommendations_button')}><button>Access Full Product List</button></a>

                            </div>
                        </div> :
                    <LoadingBlock />
                }
                        <Modal open={ this.state.openModal } onClose={ this.closeModal.bind(this) } little={ true }
                            classNames={{ overlay: 'ha-overlay', modal: 'ha-modal' }}>
                            <div className="why-buy-with-us">
                                Buying from our platform would let you access our skincare consultation services- so it's like having your personal skincare expert in your pocket for free. You can text back any skin care related questions. And we track your progress with you diligently. Plus, shipping is free.
                            </div>
                        </Modal>

                        {
                            (productsForReview && productsForReview.length > 0) &&
                            <StackedModals products={ productsForReview } getProductsForReview={ this.getProductsForReview } />
                        }
                        {this.state.showDummyDiv ?
                            <ShareModuleDummyDiv
                                name={userFirstName}
                                skinTypeAcronym={skinType}
                                dryOily={dryOily}
                                sensitiveResistant={sensitiveResistant}
                                pigmented={pigmented}
                                wrinkled={wrinkled}
                                genderId={this.state.selectedGenderId}
                                summary={this.state.description}
                            /> : null
                        }

                        <Modal open={ this.state.openReviewModal } onClose={()=>{ this.closeReviewModal() }} closeOnOverlayClick={false}
                            classNames={{ overlay: 'ha-overlay reviewProduct-overlay', modal: 'reviewProduct-confirm-modal', closeIcon: 'ha-modal-close' }}>
                            <ReviewProduct product={this.state.productInfo} closeReviewModal={this.closeReviewModal}></ReviewProduct>
                        </Modal>
            </div>

        );
    }
}

function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    const { cartGoodsCount,cartGoodsList, cartPriceSum } = helloava.myCart;
    return { isAuthenticated,cartGoodsCount,cartGoodsList, cartPriceSum };
}

function mapDispatchToProps(dispatch) {
    return {
        getUserCartData: () => dispatch(getUserCartData())
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SurveyResultNew));



// WEBPACK FOOTER //
// ./src/views/onboarding/SurveyResultNew.js